<template>
  <div v-if="hasErrors" class="alert-error sticky inline" role="alert">
    <div v-for="error in validationErrors" :key="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    attribute: {
      type: String,
      default: ''
    },
    validationErrors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasErrors() {
      return this.validationErrors.length;
    }
  }
};
</script>
